import React from "react";
import { withRouter } from "react-router-dom";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import { Button } from "@material-ui/core";
import ACCESS from "../../../ACCESS.js";
import { AuthContext } from "../../../context/authContext.js";

class Digitalizaciones extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: `digitalizar/filter/${this.props.guiaId}`,
        deleteUrl: "",
        deleteField: "g_folio",
        modUrl: "/Digitalizar/GuiaEntregada",
      },
      TableOp.Table(
        "Guias Entregadas Digitalizadas",
        [
          { label: "Folio", id: "g_folio" },
          { label: "Fecha Guia", id: "g_fecha" },
          { label: "Fecha Entrega Guia", id: "g_fecha_entrega" },
          { label: "Cliente", id: "cliente_rsocial" },
          { label: "Cant. Archivos", id: "cantidad_archivos" },
        ],
        [{ id: "edit", icon: "edit", access: [ACCESS.DIGITALIZAR.ESCANEAR] }]
      )
    );
    this.table();
  }

  render() {
    const { hasAccess } = this.context
    return (
      <div
        style={{
          margin: 10,
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 10,
          }}
        >
          {
            hasAccess([ACCESS.DIGITALIZAR.ESCANEAR]) && (
              <Button
                color="primary"
                variant={"contained"}
                onClick={() => {
                  this.props.history.push(`/Digitalizar/GuiaEntregada`);
                }}
              >
                Escanear Documentos
              </Button>)
          }
        </div>
        <this.TableRender />
      </div>
    );
  }
}

Digitalizaciones.contextType = AuthContext;
export default withRouter(Digitalizaciones);
